import { useReducer, useEffect } from "react";

import { createContainer } from "unstated-next";

import { initialState, reducer } from "./reducer";

const initAction = (state) => {
  const savedTree = JSON.parse(localStorage.getItem("preview"));
  if (savedTree) return savedTree;

  return state;
};

const useGlobalState = () => {
  const [state, dispatch] = useReducer(reducer, initialState, initAction);

  return { state, dispatch };
};
let GlobalState = createContainer(useGlobalState);

export default GlobalState;
